import { useEffect } from 'react';

/**
 * Lands here after the Microsoft OAuth callback. The backend has set the
 * session cookie by this point — we just need to signal the opener window
 * that auth succeeded and close ourselves. The opener listens for a
 * localStorage 'storage' event with key 'msAuth' to know it's time to
 * re-verify and reload.
 */
export const AuthCallback = () => {

    useEffect(() => {

        try {

            localStorage.setItem('msAuth', String(Date.now()));

        } catch (_) { /* private mode etc */ }

        // Give the opener a beat to pick up the storage event before we close.
        setTimeout(() => {

            window.close();

        }, 100);

    }, []);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 gap-2">
            <div className="text-success" style={{ fontSize: 48 }}>
                ✓
            </div>
            <h4>
                Signed in
            </h4>
            <div className="text-muted small">
                You can close this window.
            </div>
        </div>
    );

};
